import * as yup from 'yup';

const validationSchemaLogin = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  password: yup
    .string()
    .min(8, 'Password must be 8 characters or more')
    .required('Please enter your password'),
  reCaptchaCode: yup.string(),
});
const validationSchemaSignUpHirist = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  password: yup
    .string()
    .matches(/^\S+$/, 'Spaces are not allowed')
    .matches(
      /^.*(?=.{8,})((?=.*[_|\W]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    )
    .min(8, 'Password should be of minimum 8 characters length')
    .required('Please enter your password'),
});

const validationSchemaSignUp = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  password: yup
    .string()
    .matches(/^\S+$/, 'Spaces are not allowed')
    .matches(
      /^.*(?=.{8,})((?=.*[_|\W]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    )
    .min(8, 'Password should be of minimum 8 characters length')
    .required('Please enter your password'),
  confirmPassword: yup
    .string()
    .required('Please enter your password')
    .oneOf(
      [yup.ref('password')],
      'The passwords you entered do not match. Please check and try again'
    ),
  policyCheck: yup
    .boolean()
    .required('Please agree to the terms and conditions to continue')
    .oneOf([true], 'Please agree to the terms and conditions to continue'),
});

const validationSchemaForgot = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),
  reCaptchaCode: yup.string(),
});

const validationSchemaOtp = yup.object({
  otp: yup.number().required('Please enter a valid OTP'),
});

const validationSchemaSetPassword = yup.object({
  password: yup
    .string()
    .matches(/^\S+$/, 'Spaces are not allowed')
    .matches(
      /^.*(?=.{8,})((?=.*[_|\W]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    )
    .min(8, 'Password should be of minimum 8 characters length')
    .required('Please enter your password'),
  confirmPassword: yup
    .string()
    .required('Please enter your password')
    .oneOf(
      [yup.ref('password')],
      'The passwords you entered do not match. Please check and try again'
    ),
});

const validationSchemaParticipantRegistration = yup.object({
  name: yup.string().required('Please enter your name'),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your email address'),

  password: yup
    .string()
    .matches(/^\S+$/, 'Spaces are not allowed')
    .matches(
      /^.*(?=.{8,})((?=.*[_|\W]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    )
    .min(8, 'Password should be of minimum 8 characters length')
    .required('Please enter your password'),
  gender: yup
    .string()
    .oneOf(['male', 'female'], 'Please select a valid gender')
    .required('Please select your gender'),
  dob: yup.date().required('Please enter your date of birth'),
  expYear: yup
    .number()
    .positive('Years of experience must be a positive number')
    .integer()
    .required('Please enter your years of experience'),
  expMonth: yup
    .number()
    .positive('Months of experience must be a positive number')
    .integer()
    .required('Please enter your months of experience'),
  phone: yup
    .string()
    .matches(/^\d{10}$/, 'Phone number must be 10 digits')
    .required('Please enter your phone number'),
  // attachResume: yup.mixed().required('Please attach your resume'),
  instituteName: yup.string().required('Please enter your institute name'),
  passingYear: yup
    .number()
    .positive('Passing year must be a positive number')
    .integer()
    .required('Please enter your passing year'),
  functionalArea: yup.string().required('Please enter your functional area'),
  preferredCompany: yup
    .string()
    .required('Please enter your preferred company'),
});

export {
  validationSchemaLogin,
  validationSchemaSignUp,
  validationSchemaForgot,
  validationSchemaOtp,
  validationSchemaSetPassword,
  validationSchemaParticipantRegistration,
  validationSchemaSignUpHirist,
};
